<div
  class="go-sidepanel"
  cdkTrapFocus
  goMonitorTabEvent
  (onTabbedOut)="onTabOut()"
  tabindex="-1"
  [attr.role]="sidepanelData.options.role ?? null"
  [attr.aria-modal]="sidepanelData.options.ariaModal ? 'true' : null"
  [attr.aria-label]="sidepanelData.options.ariaLabel ?? null"
  [attr.aria-labelledby]="sidepanelData.options.ariaLabel ? null : (sidepanelData.options.ariaLabelledBy ?? (sidepanelData.options.title ? titleId : null))"
  #main>
  @if (sidepanelData.options.title) {
    <div class="go-sidepanel-header">
      <h1 [id]="titleId">{{sidepanelData.options.title}}</h1>
      <button type="button" class="close-btn btn-none" (click)="close()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
  }

  <div class="go-sidepanel-body">
    <div class="go-sidepanel-content">
      <ng-template goAnchor></ng-template>
    </div>
  </div>

  @if (!sidepanelData.options.noFooter) {
    <div class="go-sidepanel-footer">
      <button class="primary-btn close-btn" (click)="close()" translate="common_close"></button>
    </div>
  }
</div>
